import AccountStatementStore from "@state/stores/account-statement/AccountStatementStore";
import { createContext } from "react";

export const AccountStatementContext =
	createContext<AccountStatementStore | null>(null);
